'use client';

import { createContext, useContext, type ReactNode } from 'react';

const DEFAULT_BRAND_NAME = 'ONEPAGE';

const BrandContext = createContext<string>(DEFAULT_BRAND_NAME);

/**
 * Provides the admin-configured homepage display name to the client tree.
 * The value is seeded from the server (root layout) so it renders correctly
 * for logged-out visitors with no client fetch / flash.
 */
export function BrandProvider({ value, children }: { value: string; children: ReactNode }) {
    return <BrandContext.Provider value={value || DEFAULT_BRAND_NAME}>{children}</BrandContext.Provider>;
}

export function useBrandName(): string {
    return useContext(BrandContext);
}
